exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-container-empty-icon[data-v-51f4190b] {\n  text-align: center;\n  color: rgba(0, 0, 0, 0.2);\n  font-size: 100px;\n  margin: 3rem 0;\n  padding: 3rem 0;\n}", ""]);

// exports
